export const HeaderMenu = [
    {
       id:"1", path:"/", title:"Home"
    },
   //  {
   //      id:"2", path:"/services", title:"Services"
   //   },
     {
        id:"3", path:"/specialties", title:"Specialities"
     },
     {
        id:"4", path:"/blog", title:"Blog"
     },
     {
        id:"5", path:"/about-us", title:"About Us"
     },

    
];